import { computed, ref } from 'vue';
import { USER_ACTIONS, USER_SUBJECTS } from '@/utils/const';
import { useRoute } from 'vue-router/composables';
import { watchEffect } from 'vue';
import {
  createDeveloperToolsSidebarItem,
  createManufacturingSidebarItem,
  createLossesSidebarItem,
  createAnalyticsSidebarItem,
  sidebarContainsRoute,
} from './sidebarNavigation.mjs';
const sidebarTypes = {
  MAIN: 'MAIN',
  PROFILE: 'PROFILE',
  COMPANY: 'COMPANY',
  MASTER_DATA: 'MASTER_DATA',
};

const masterDataSidebarItems = [
  {
    $ID: 'LossReasons',
    Action: {
      $Type: 'OpenPage',
      Page: 'LossReasons',
    },
    Icon: 'loss-reasons',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.lossReasons',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.COMPANY_SETTINGS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'Products',
    Action: {
      $Type: 'OpenPage',
      Page: 'Products',
    },
    showLock: true,
    Icon: 'box',
    IconClass: 'fill-icon',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.products',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.PRODUCTS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'Materials',
    Action: {
      $Type: 'OpenPage',
      Page: 'Materials',
    },
    showLock: true,
    Icon: 'shopping-bag',
    ViewBox: '0 0 24 24',
    Caption: 'sidebar.titles.materials',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.PRODUCTS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'Containers',
    Action: {
      $Type: 'OpenPage',
      Page: 'Containers',
    },
    showLock: true,
    Icon: 'inventory_2',
    IconClass: 'fill-icon',
    ViewBox: '0 0 24 24',
    Caption: 'sidebar.titles.containers',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.PRODUCTS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'Characteristics',
    Action: {
      $Type: 'OpenPage',
      Page: 'Characteristics',
    },
    showLock: true,
    Icon: 'calculate',
    IconClass: 'fill-icon',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.characteristics',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.PRODUCT_CHARACTERISTICS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'MeasurementUnits',
    Action: {
      $Type: 'OpenPage',
      Page: 'MeasurementUnits',
    },
    Icon: 'design-services',
    IconClass: 'fill-icon',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.measurementUnits',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.COMPANY_SETTINGS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'ChecklistDefinitions',
    Action: {
      $Type: 'OpenPage',
      Page: 'ChecklistDefinitions',
    },
    showLock: true,
    Icon: 'receipt-long',
    IconClass: 'fill-icon',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.checklists',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.CHECKLISTS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'Templates',
    Action: {
      $Type: 'OpenPage',
      Page: 'Templates',
    },
    showLock: true,
    Icon: 'templates',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.templates',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.REPORT_TEMPLATE,
      action: USER_ACTIONS.READ,
    },
  },
];

const companySidebarItems = [
  {
    $ID: 'General',
    Action: {
      $Type: 'OpenPage',
      Page: 'GeneralSettingsCompany',
    },
    Icon: 'company-data',
    ViewBox: '0 0 22 22',
    Caption: 'sidebar.titles.companyData',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.COMPANY_SETTINGS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'Integrations',
    Action: {
      $Type: 'OpenPage',
      Page: 'Integrations',
    },
    Icon: 'integrations',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.integrations',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.INTEGRATIONS,
      action: USER_ACTIONS.READ,
    },
  },
  {
    $ID: 'Notifications',
    Action: { $Type: 'OpenPage', Page: 'Notifications' },
    Icon: 'chat-bot',
    ViewBox: '0 0 24 24',
    Caption: 'sidebar.titles.notifications',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.NOTIFICATIONS,
      action: USER_ACTIONS.READ,
    },
  },
  createDeveloperToolsSidebarItem({
    userActions: USER_ACTIONS,
    userSubjects: USER_SUBJECTS,
  }),
  {
    $ID: 'Users',
    Action: {
      $Type: 'OpenPage',
      Page: 'Users',
    },
    Icon: 'user-sidebar',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.users',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.COMPANY_USERS,
      action: USER_ACTIONS.READ,
    },
  },

  {
    $ID: 'AddWorkCenter',
    Caption: 'sidebar.titles.addWorkCenter',
    Icon: 'plus-circle',
    Action: {
      $Type: 'OpenPage',
      Page: 'AddWorkCenter',
    },
    group: 'addWorkCenter',
    ability: {
      subject: USER_SUBJECTS.NEW_WORK_CENTER,
      action: USER_ACTIONS.READ,
    },
  },
];

const profileSidebarItems = [
  {
    $ID: 'Profile',
    Action: {
      $Type: 'OpenPage',
      Page: 'SettingsProfile',
    },
    Icon: 'settings',
    Caption: 'sidebar.titles.profile',
    group: 'main',
  },
  {
    $ID: 'Password',
    Action: {
      $Type: 'OpenPage',
      Page: 'Password',
    },
    Icon: 'lock',
    Caption: 'sidebar.titles.password',
    group: 'main',
  },
];

const mainSidebarItems = [
  // {
  //   $ID: 'Overview',
  //   Action: {
  //     $Type: 'OpenPage',
  //     Page: 'Overview',
  //   },
  //   Icon: 'overview',
  //   IconClass: 'fill-icon',
  //   Caption: 'sidebar.titles.overview',
  //   group: 'main',
  // },
  {
    $ID: 'WorkCenters',
    Action: {
      $Type: 'OpenPage',
      Page: 'WorkCenters',
    },
    Icon: 'work-center',
    Caption: 'sidebar.titles.work-centers',
    IconClass: 'fill-icon',
    group: 'main',
  },
  {
    $ID: 'GridView',
    Action: {
      $Type: 'OpenPage',
      Page: 'GridView',
    },
    Icon: 'grid-view',
    IconClass: 'fill-icon',
    Caption: 'sidebar.titles.grid-view',
    group: 'main',
    ability: {
      subject: USER_SUBJECTS.WORK_CENTERS_GRIDS,
      action: USER_ACTIONS.READ,
    },
  },

  createLossesSidebarItem({
    userActions: USER_ACTIONS,
    userSubjects: USER_SUBJECTS,
  }),

  createManufacturingSidebarItem({
    userActions: USER_ACTIONS,
    userSubjects: USER_SUBJECTS,
  }),

  createAnalyticsSidebarItem({
    userActions: USER_ACTIONS,
    userSubjects: USER_SUBJECTS,
  }),
  {
    $ID: 'Quality',
    Icon: 'metric-quality',
    IconClass: 'fill-icon',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.quality',
    group: 'main',
    showLock: true,
    Items: [
      {
        $ID: 'Inspections',
        Action: {
          $Type: 'OpenPage',
          Page: 'Inspections',
        },
        showLock: true,
        Icon: 'rubric',
        IconClass: 'fill-icon',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.inspections',
        group: 'main',
        ability: {
          subject: USER_SUBJECTS.INSPECTIONS,
          action: USER_ACTIONS.READ,
        },
      },
      {
        $ID: 'SpcAnalysis',
        Action: {
          $Type: 'OpenPage',
          Page: 'SpcAnalysis',
        },
        showLock: true,
        Icon: 'spc',
        IconClass: 'fill-icon',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.spcAnalysis',
        group: 'main',
        ability: {
          subject: USER_SUBJECTS.PRODUCT_SPC_ANALYSIS,
          action: USER_ACTIONS.READ,
        },
      },
      {
        $ID: 'QualityChecklists',
        Action: {
          $Type: 'OpenPage',
          Page: 'QualityChecklists',
        },
        showLock: true,
        Icon: 'receipt-long',
        IconClass: 'fill-icon',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.checklists',
        group: 'main',
        ability: {
          subject: USER_SUBJECTS.CHECKLISTS,
          action: USER_ACTIONS.READ,
        },
      },
    ],
  },
  {
    $ID: 'ProcessControl',
    Icon: 'company-data',
    ViewBox: '0 0 22 22',
    Caption: 'sidebar.titles.processControl',
    group: 'main',
    showLock: true,
    Items: [
      {
        $ID: 'ProcessControlChecklists',
        Action: {
          $Type: 'OpenPage',
          Page: 'ProcessControlChecklists',
        },
        showLock: true,
        Icon: 'receipt-long',
        IconClass: 'fill-icon',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.checklists',
        group: 'main',
        ability: {
          subject: USER_SUBJECTS.CHECKLISTS,
          action: USER_ACTIONS.READ,
        },
      },
    ],
  },
];
const sidebarType = ref(sidebarTypes.MAIN);
export default function useSidebar() {
  const route = useRoute();

  const sidebarItems = ref([]);
  const isSidebarOpen = ref(false);

  let _onClose = null;

  const isMainSidebar = computed(() => {
    return sidebarType.value === sidebarTypes.MAIN;
  });

  const isCompanySidebar = computed(() => {
    return sidebarType.value === sidebarTypes.COMPANY;
  });

  const isProfileSidebar = computed(() => {
    return sidebarType.value === sidebarTypes.PROFILE;
  });

  const isMasterDataSidebar = computed(() => {
    return sidebarType.value === sidebarTypes.MASTER_DATA;
  });

  const initSidebar = (routeName = null) => {
    routeName = routeName ?? route.name;

    if (sidebarContainsRoute(companySidebarItems, routeName)) {
      sidebarType.value = sidebarTypes.COMPANY;
      return;
    }

    if (sidebarContainsRoute(profileSidebarItems, routeName)) {
      sidebarType.value = sidebarTypes.PROFILE;
      return;
    }

    if (sidebarContainsRoute(masterDataSidebarItems, routeName)) {
      sidebarType.value = sidebarTypes.MASTER_DATA;
      return;
    }
  };

  const openSidebar = () => {
    isSidebarOpen.value = true;
  };

  const closeSidebar = () => {
    isSidebarOpen.value = false;
    if (_onClose) {
      _onClose();
    }
  };

  const onCloseSidebar = (onClose) => {
    _onClose = onClose;
  };

  const setSidebarType = (type) => {
    sidebarType.value = type;
  };

  watchEffect(() => {
    initSidebar(route.name);
  });

  watchEffect(() => {
    if (sidebarType.value == sidebarTypes.COMPANY) {
      sidebarItems.value = companySidebarItems;
    } else if (sidebarType.value == sidebarTypes.PROFILE) {
      sidebarItems.value = profileSidebarItems;
    } else if (sidebarType.value == sidebarTypes.MASTER_DATA) {
      sidebarItems.value = masterDataSidebarItems;
    } else {
      sidebarItems.value = mainSidebarItems;
    }
  });

  return {
    sidebarTypes: sidebarTypes,
    sidebarType,
    sidebarItems,
    initSidebar,
    openSidebar,
    closeSidebar,
    onCloseSidebar,
    isSidebarOpen,
    isMainSidebar,
    isCompanySidebar,
    isProfileSidebar,
    isMasterDataSidebar,
    setSidebarType,
  };
}
